
module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'id',
    },
    {
      name: '应用名称',
      format: (row) => {
        return row.baidu_params?.app_name || '-';
      },
    },
    {
      name: '渠道包名称',
      value: 'name',
    },
    {
      name: '操作',
      width: 90,
      align: 'center',
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-button',
          {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                s.onDataDialogConfirm(row);
              },
            },
          },
          '选择',
        );
        return ele;
      },
    },
  ];
};
